<nz-layout class="im_main"  >
    <div class="menu_sider" dragmove (move)="onMove($event)" [dragClassName]="'messageContext'">
        <ul class="im_menu" nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="collapsedMenu">
            <li nz-menu-item class="user_head" (click)="menuClick(0)">
                <nz-avatar nzIcon="user" [nzShape]="'square'" [nzSrc]="settings.user.avatar|src"></nz-avatar>
            </li>
            <li nz-menu-item [nzSelected]="settings.messageBox.selectIndex==1" (click)="menuClick(1)">
                <nz-badge [nzCount]="TotalUnreadNumber">
                    <i class="menu_ico_color" nz-icon nzType="message"></i>
                </nz-badge>
            </li>
            <li nz-menu-item [nzSelected]="settings.messageBox.selectIndex==2" (click)="menuClick(2)">
                <i class="menu_ico_color" nz-icon nzType="team"></i>

            </li>
            <li nz-menu-item [nzSelected]="settings.messageBox.selectIndex==3" (click)="menuClick(3)">
                <i class="menu_ico_color" nz-icon nzType="cloud" nzTheme="outline"></i>

            </li>
        </ul>
    </div>
    <nz-sider class="mail_context" nzWidth="250px">
        <div class="left_context">
            <div class="head-item-search">
                <nz-input-group #search class="header-search" [nzPrefix]="suffixIconSearch" [nzSize]="'small'">
                    <input type="text" nz-input placeholder="{{'menu.search.placeholder'|translate}}"
                        (focus)="onSearchFocus()" (blur)="onSearchBlur()" />
                </nz-input-group>
                <ng-template #suffixIconSearch>
                    <i *ngIf="!searchEditing" class="header-search-ico" nz-icon nzType="search"></i>
                    <i *ngIf="searchEditing" class="header-search-ico" nz-icon nzType="edit"></i>
                </ng-template>
                <div class="header-addSession">
                    <button nz-button nzSize="small" nzType="primary" class="header-addSession-btn"><i nz-icon
                            nzType="plus" nzTheme="outline"></i></button>
                </div>
            </div>
            <div class="left_list">
                <ng-container [ngSwitch]="settings.messageBox.selectIndex">
                    <ng-container *ngSwitchCase="1">
                        <nz-spin [nzSpinning]="loadingSessionList">
                            <div *ngFor="let item of sessionList" class="session_list_item"
                                (contextmenu)="sessionMenu($event, sessionDropdownMenu,item)"
                                [ngClass]="{'session_list_item_select':checkCurrentSession(item)}"
                                (click)="conversationSessionClick(item)">
                                <div class="session_list_item_meta">
                                    <div class="session_list_item_meta_avatar">
                                        <nz-badge [nzCount]="item.UnreadNumber">
                                            <nz-avatar [nzShape]="'square'" [nzSize]="40" [nzIcon]="'user'"
                                                nzSrc="{{item.HeadImg|src}}"></nz-avatar>
                                        </nz-badge>
                                    </div>
                                    <div class="session_list_item_meta_context" style="flex:1 0;">
                                        <div class="session_list_item_meta_title">{{item.Name}}</div>
                                        <div class="session_list_item_meta_description">{{item.MessageText}}</div>
                                    </div>
                                </div>
                                <div class="session_list_item_meta_time">{{item.SendTime| chatDate}}</div>
                            </div>
                            <nz-dropdown-menu #sessionDropdownMenu="nzDropdownMenu">
                                <ul nz-menu class="session_dropdown_menu">
                                    <li nz-menu-item (click)="sessionMenuItemClick($event)">置顶</li>
                                    <li nz-menu-divider></li>
                                    <li nz-menu-item (click)="deleteSession()">删除聊天</li>
                                </ul>
                            </nz-dropdown-menu>
                        </nz-spin>
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                        <nz-spin [nzSpinning]="loadingMailList">
                            <div class="mail_manager"><button nz-button nzBlock nzType="default"
                                    class="mail_manager_text">通讯录管理</button></div>
                            <ng-container *ngFor="let m of mailList index as i">
                                <div class="initials_tag" *ngIf="i==0||mailList[i-1].Letter!=m.Letter">{{m.Letter}}
                                </div>
                                <div class="session_list_item"
                                    [ngClass]="{'session_list_item_select':checkCurrentMailInfo(m)}"
                                    (click)="mailItemClick(m)">
                                    <div class="session_list_item_meta t2_center">
                                        <div class="session_list_item_meta_avatar">
                                            <nz-avatar [nzShape]="'square'" [nzSize]="34" [nzIcon]="'user'"
                                                nzSrc="{{m.Data.HeadImg|src}}"></nz-avatar>
                                        </div>
                                        <div class="mail_manager_text">{{m.Data.UserNick}}</div>
                                    </div>
                                </div>
                                <nz-divider class="mail_divider" nzPlain
                                    *ngIf="i<mailList.length-1&&mailList[i+1].Letter!=m.Letter"></nz-divider>
                            </ng-container>
                        </nz-spin>
                    </ng-container>
                </ng-container>
            </div>
        </div>

    </nz-sider>
    <nz-layout class="nz-header-layout">
        <nz-header class="msg-header" dragmove (move)="onMove($event)" [dragClassName]="'messageContext'">
            <div class="app-header">
                <ul class="ul-head">
                    <li (click)="hide()">
                        <div class="app-header-ul-item"><i nz-icon nzType="minus" nzTheme="outline"></i></div>
                    </li>
                    <li (click)="max()">
                        <div class="app-header-ul-item">
                            <i nz-icon [nzType]="settings.messageBox.max? 'fullscreen-exit' : 'fullscreen'"></i>
                        </div>
                    </li>
                    <li (click)="hide()">

                        <div class="app-header-ul-item"><i nz-icon nzType="close" nzTheme="outline"></i></div>
                    </li>
                </ul>
            </div>
            <div class="app-header-title">
                <p *ngIf="selectSession&&settings.messageBox.selectIndex==1">{{ selectSession?.Name}}</p>
            </div>
        </nz-header>
        <ng-container [ngSwitch]="settings.messageBox.selectIndex">
            <!-- <ng-container *ngSwitchCase="0">
<nz-content>个人中心</nz-content>
</ng-container> -->
            <ng-container *ngSwitchCase="1">
                <ng-container *ngIf="this.selectSession else blankTemp">
                    <nz-content id="chatContext" (mousewheel)="onmousewheel($event)" (scroll)="onscroll($event)">
                        <div class="msg-items">
                            <div class="more">
                                <nz-spin *ngIf="loadingChatRecord" nzSimple [nzSize]="'small'"></nz-spin>
                                <a *ngIf="!loadingChatRecord&&pageInfo.pageIndex!=pageInfo.totalPage&&pageInfo.totalPage>0"
                                    (click)="morePage()">查看更多消息</a>
                            </div>
                            <div class="chat-item" *ngFor="let item of this.chatRecordData index as i"
                                [ngClass]="{'me':item.IsMe}">
                                <div class="chat-status"
                                    [ngStyle]="{'visibility':showStatus(item,i)?'visible':'hidden'}">
                                    {{item.SendTime|chatDate}}&nbsp;</div>
                                <div class="chat-context">
                                    <div class="avatar">
                                        <nz-avatar nzIcon="user" [nzShape]="'square'"
                                            [nzSrc]="item.SendUserHeadImg|src">
                                        </nz-avatar>
                                    </div>
                                    <div class="chatDetial" [ngClass]="{'group':item.ObjectType==1}">
                                        <div class="chatTime" *ngIf="!item.IsMe&&item.ObjectType==1">
                                            <ng-container *ngIf="!item.IsMe else msg">
                                                {{item.SendName}}&nbsp;&nbsp;
                                                <!-- {{item.SendTime|date:'yyyy-MM-dd HH:mm'}} -->
                                            </ng-container>
                                            <ng-template #msg>
                                                <!-- {{item.SendTime|date:'yyyy-MM-dd HH:mm'}}&nbsp;&nbsp; -->
                                                {{item.SendName}}
                                            </ng-template>
                                        </div>
                                        <div class="chat-text-item">
                                            <div class="chatText" [ngClass]="{'media':item.Type!=0}">
                                                <ng-container [ngSwitch]="item.Type">
                                                    <app-text-element *ngSwitchCase="0" [text]="item.MessageText">
                                                    </app-text-element>
                                                    <app-image-element *ngSwitchCase="1" [message]="item"
                                                        (imgClick)="onImgPreview($event)">
                                                    </app-image-element>
                                                    <app-live-element *ngSwitchCase="4" [message]="item"
                                                        (joinLive)="onJoinLive($event)">
                                                    </app-live-element>

                                                    <app-file-element [message]="item" *ngSwitchCase="5">
                                                    </app-file-element>
                                                </ng-container>
                                                <!-- <ng-template  *ngFor="let msg of get as i"></ng-template> -->
                                            </div>
                                            <div class="sendStatus" *ngIf="item.SendStatus==0">
                                                <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i>
                                                </ng-template>
                                                <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </nz-content>
                    <nz-footer [ngClass]="{'chat-focus':textFocus}">
                        <div class="toolMenu">
                            <div class="tool">
                                <span class="tool_span" nz-popover nzPopoverTrigger="click"
                                    [nzPopoverContent]="contentTemplate" [(nzPopoverVisible)]="showEmojiPicker">
                                    <i nz-icon nzType="smile" nzTheme="outline"></i>
                                    <ng-template #contentTemplate>
                                        <div class="emoji_main">
                                            <!-- <emoji-mart [set]="'apple'" [include]="emoji" [showPreview]="false"
[enableSearch]="false" (emojiClick)="emojiClick($event)"></emoji-mart> -->
                                            <app-emoji-picker (select)="emojiClick($event)"></app-emoji-picker>
                                        </div>
                                    </ng-template>
                                </span>
                                <span class="tool_span" (click)="onSelectImage()">
                                    <i nz-icon nzType="picture" nzTheme="outline">
                                        <input #selectImageFile [accept]="acceptImageStr" (change)="uploadImage($event)"
                                            type="file" style="width: 0px;visibility: hidden;" /></i>
                                </span>
                                <span class="tool_span" (click)="onSelectFile()"><i nz-icon nzType="folder"
                                        nzTheme="outline">
                                        <input #selectFile (change)="uploadFile($event)" type="file"
                                            style="width: 0px;visibility: hidden;" /></i></span>
                                <span class="tool_span"><i nz-icon nzType="message" nzTheme="outline"></i></span>

                            </div>
                            <div class="tool media_tool">

                                <span class="tool_span" (click)="shareScreen()"><i nz-icon nzType="desktop"
                                        nzTheme="outline"></i></span>
                                <span class="tool_span"><i nz-icon nzType="video-camera" nzTheme="outline"></i></span>
                            </div>
                        </div>
                        <div class="textarea" style="user-select: none;" [ngStyle]="{'width':settings.messageBox.max?'100%':'500px'}"
                            #messageTextElement (focus)="onTextareaFocus()" (blur)="onTextareaBlur()"
                            (keydown)="onTextKeyDown($event)" contenteditable="true" (keyup)="textareaInput($event)"
                            ondragstart="return false" (paste)="onPaste($event)">
                        </div>

                        <div class="btn_send">
                            <button nz-button nzType="default" (click)="sendTextMessage()" nz-tooltip #notNulltooltip
                                nzTooltipTitle="不能发送空白信息" [nzTooltipTrigger]="'null'"
                                nzTooltipPlacement="topRight">发送</button>
                        </div>


                    </nz-footer>
                </ng-container>

            </ng-container>
            <ng-container *ngSwitchCase="2">
                <nz-content *ngIf="this.selectMailItem else blankTemp">
                    <div class="mail_info">
                        <div class="mail_head">
                            <div class="mail_head_name">
                                <h1>{{selectMailItem.Data.UserNick}}<img class="mail_head_seximg"
                                        [src]="selectMailItem.Data.Sex=='男'?'./assets/img/chat/man.png':'./assets/img/chat/woman.png'" />
                                </h1>
                                <div class="mail_head_name_sig">{{selectMailItem.Data.Signature}}</div>
                            </div>
                            <nz-avatar [nzShape]="'square'" [nzSize]="60" [nzIcon]="'user'"
                                nzSrc="{{this.selectMailItem?.Data.HeadImg|src}}"></nz-avatar>
                        </div>
                        <nz-divider nzPlain></nz-divider>
                        <div class="mail_info_context">
                            <div class="mail_info_context_item">
                                <span class="mail_info_context_title">部&nbsp;&nbsp;&nbsp;门</span>
                                <span class="mail_info_context_text">{{selectMailItem.Data.DepartmentName}}</span>
                            </div>
                            <div class="mail_info_context_item">
                                <span class="mail_info_context_title">手机号</span>
                                <span class="mail_info_context_text">{{selectMailItem.Data.Phone}}</span>
                            </div>

                            <div class="mail_info_context_item">
                                <span class="mail_info_context_title">邮&nbsp;&nbsp;&nbsp;箱</span>
                                <span class="mail_info_context_text">{{selectMailItem.Data.Email}}</span>
                            </div>
                            <div class="mail_info_context_item">
                                <span class="mail_info_context_title">标&nbsp;&nbsp;&nbsp;签</span>
                                <span class="mail_info_context_text">{{selectMailItem.Data.Tag}}</span>
                            </div>
                        </div>
                        <nz-divider nzPlain></nz-divider>
                        <div class="mail_info_context_send"><button nz-button nzBlock nzType="primary"
                                (click)="addSession(0)">发消息</button>
                        </div>
                    </div>

                </nz-content>
            </ng-container>
            <ng-container *ngSwitchCase="3">
                <nz-content>云盘</nz-content>
            </ng-container>
            <ng-template #blankTemp>
                <div class="nullContext">
                    <nz-content>
                        <nz-empty [nzNotFoundImage]="null" [nzNotFoundContent]="''"></nz-empty>
                    </nz-content>
                </div>
            </ng-template>
        </ng-container>
    </nz-layout>
</nz-layout>
 